import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, StateToken} from '@ngxs/store';
import {Message} from "../models/message.model";
import {MessageApiService} from "../api/message.api.service";
import {GetMessageListAction} from "../actions/message.actions";
import {tap} from "rxjs/operators";
import {DateTime} from "luxon";

export interface MessageStateModel {
  messageList: Message[],
  message: Message,
}

const initialState: MessageStateModel = {
  messageList: null,
  message: null
};

const Message_STATE_TOKEN = new StateToken<MessageStateModel>('message');

@State<MessageStateModel>({
  name: Message_STATE_TOKEN,
  defaults: initialState
})
@Injectable()
export class MessageState {

  constructor(
    private messageApiService: MessageApiService
  ) {
  }

  @Action(GetMessageListAction)
  handleGetMessageListAction(ctx: StateContext<MessageStateModel>, action: GetMessageListAction) {

    const page = action.payload.page;
    const size = action.payload.size;

    return this.messageApiService.getMessageList(page, size).pipe(
      tap(messageList => {
        ctx.patchState({
          messageList
        })
      }))
  }


  @Selector()
  static getNewMessageList(state: MessageStateModel): Message[] {
    if (state?.messageList) {
      return state.messageList.filter(m => {
        let msgDateTime = DateTime.fromISO(m.date);//por estar mal guardada la hora en la base como si fuera utc, necesito esto
        // console.log(msgDateTime.toISO())
        let localNow = DateTime.local();
        // console.log(localNow.toISO())
        // console.log("messages last arrived " + localNow.diff(msgDateTime,'hours').hours)
        return localNow.diff(msgDateTime,'hours').hours >= 0 && localNow.diff(msgDateTime,'hours').hours < 24;
      })
    } else {
      return [];
    }
  }

  @Selector()
  static getMessageList(state: MessageStateModel): Message[] {
    return state?.messageList
  }

  @Selector()
  static getMessage(state: MessageStateModel) {
    return state?.message
  }

}
